module.exports = __webpack_public_path__ + "img/minus.8e72d776.svg";